import {
  LOGIN_SUCCESS,
  LOGIN_FAIL,
  LOGOUT,
  USER_WALLET,
} from "../actions/types";
import StateLoader from "../StateLoader";
const stateLoader = new StateLoader();

export const AuthReducer = (
  state = stateLoader.loadStateByReducer("authReducer"),
  action
) => {
  const { type, payload } = action;

  switch (type) {
    case LOGIN_SUCCESS:
      return {
        ...state,
        isLoggedIn: true,
        token: payload.user.token,
        user: payload.user.user,
      };
    case LOGIN_FAIL:
      return {
        ...state,
        isLoggedIn: false,
        token: null,
        user: null,
      };
    case LOGOUT:
      return {
        ...state,
        isLoggedIn: false,
        token: null,
        user: null,
      };
    case USER_WALLET:
      return {
        ...state,
        user: payload.user,
      };
    default:
      return state;
  }
};
